export function receptionLabel(conversation, agents = []) {
  if (conversation.status === 'ai') return 'AI'
  if (conversation.status === 'waiting_human') return '待接入'
  if (conversation.status === 'closed') return '已结束'
  if (conversation.status !== 'human' || !conversation.assigned_agent_id) return '未分配'
  const id = conversation.assigned_agent_id
  return agents.find(agent => agent.id === id)?.name || id
}
